/***** SCRIPTS POUR GERER LES OFFRES D'EMPLOIS *****/

    $('document').ready(setupJobOffers);

    function setupJobOffers() {
        initJobOffersListPage();
        $(window).resize(function() {
            if(($('.joboffers-offer.show').length === 0 && $(window).width() < 1000) || $(window).width() >= 1000) {
                $('html, body').removeAttr('style');
                $("body").removeClass("show-offer");
                if($(window).scrollTop() < 150) $('.navigation').removeClass('fixed');
            }

            if($('.joboffers-offer.show').length !== 0 && $(window).width() < 1000) {
                $('.navigation').addClass('fixed');
                $("body").addClass("show-offer");
                $('html, body').css('overflow', 'hidden');
            }
        });
    }

    // Page des offres d'emplois
    function initJobOffersListPage() {
        $('.jobcard-link').click(getJobofferInfos);
        $('.joboffers-offer.show').scroll(showHideStickyMenu);
        if($('.joboffers-offer.show').length !== 0 && $(window).width() < 1000) {
            $('.navigation').addClass('fixed');
            $("body").addClass("show-offer");
            $('html, body').css('overflow', 'hidden');
        }

        // Scroller vers l'offre quand on l'ouvre depuis une URL externe
        if($('body').hasClass('single-offre-emploi')) {
            if($(window).width() >= 1000) {
                var offset = $('#offer').offset().top - 200;
                $('html, body').animate({scrollTop: offset}, 1000);
            }
        }

        // Initialisation du bouton de retour des offres d'emplois
        $(".joboffers-offer .btn-return-offers").click(function(e) {
            $(".joboffers-offer").removeClass("show");
            $('.joboffers-loader').removeClass('show');
            $('.jobcard.current').removeClass('current');
            $("body").removeClass("show-offer");
            $('html, body').removeAttr('style');
        });
    }

    // Fonction pour charger les offres d'emplois en AJAX
    function getJobofferInfos(e) {
        e.preventDefault();

        $('.joboffers-loader').addClass('show');

        // On réinitialise le formulaire de candidature
        $('.wpcf7-form').trigger("reset");
        $('.wpcf7-form .form').fadeIn(400);
        $('.wpcf7-form .validation-msg').fadeOut(200);
        $('.wpcf7-form .form .uploadfilesection .filename').html('');
        $('.wpcf7-form .form .uploadfilesection .btn-secondary').removeClass('active');

        if ( $(this).hasClass("current") ) {
            $(".joboffers-offer").addClass("show");
            if($(".joboffers-offer").length !== 0) {
                var offset = $(".joboffers-offer").offset().top;
                if($(window).width() < 1000) {
                    $("body").addClass("show-offer");
                    $('html, body').css('overflow', 'hidden');
                }else {
                    $('html, body').animate({scrollTop: offset}, 'slow');
                }
            }
        }else {
            $('.jobcard.current').removeClass('current');
            $(this).parent().addClass("current");
            // Chargement
            $(".joboffers-offer").removeClass("show").addClass("load");
            var offset = $(".joboffers-offer").offset().top;
            if($(window).width() < 1000) {
                $('html, body').css('overflow', 'hidden');
                $("body").addClass("show-offer");
            }else {
                $('html, body').animate({scrollTop: offset}, 'slow');
            }

            // On charge l'offre d'emploi en AJAX
            var id = $(this).attr('data-id');
            var url = $(this).attr('href');
            var data = {
                'action': 'load_joboffer_by_ajax',
                'post_id': id,
                'security': site.security
            };
            if($('html').attr('lang') === 'fr-FR') history.pushState( { url: url, id: id }, "", url);
            $.post(site.ajaxurl, data, function(response) {
                if($.trim(response) !== '') {
                    $('#offer').html(response);
                    $(".joboffers-offer").removeClass("load");
                    $(".joboffers-offer").addClass("show");
                    $('.joboffers-loader').removeClass('show');
                    $('.wpcf7 input[name="offre"]').val($('.headeroffer-title').html());
                    $('.wpcf7 input[name="id_offer"]').val(id);
                    $('#offer a, #offer .is-anchor').click(goToAnchor);
                    $('.joboffers-offer .error-msg').fadeOut(300);
                }else {
                    console.log('Erreur de chargement offre emploi');
                }
            });
        }
    }